import RibbonRaid from './ConnectedRibbonRaid';

export default RibbonRaid;
